import { EXPERIENCE } from "../../data/portfolioData";
import { ILLUSTRATIONS } from "../ui/Illustrations";
import MovingBorder from "../ui/MovingBorder";
import Reveal from "../ui/Reveal";

// Each card gets its own border-glow speed so they don't pulse in sync.
const DURATIONS = [14000, 18000, 16000, 20000];

const Experience = () => (
  <section id="experience" className="py-20 w-full">
    <Reveal>
      <h2 className="heading">
        My <span className="text-accent">Experience</span>
      </h2>
    </Reveal>
    <div className="w-full mt-12 grid lg:grid-cols-2 grid-cols-1 gap-10">
      {EXPERIENCE.map((job, i) => {
        const Illustration = ILLUSTRATIONS[job.illustration];
        return (
          <Reveal key={`${job.company}-${job.dates}`} delay={(i % 2) * 0.1} className="h-full">
            <MovingBorder duration={DURATIONS[i % DURATIONS.length]} className="h-full">
              <div className="flex md:flex-row flex-col md:items-center gap-6 md:gap-8 p-6 md:p-8 lg:p-10 h-full">
                {Illustration && (
                  <Illustration className="w-24 md:w-28 lg:w-32 shrink-0 drop-shadow-[0_10px_18px_rgba(232,69,122,0.25)]" />
                )}
                <div>
                  <h3 className="text-start text-xl md:text-2xl font-bold leading-snug">{job.role}</h3>
                  <div className="flex items-center gap-2 mt-1">
                    {job.logo && (
                      <img src={job.logo} alt="" className="w-5 h-5 rounded-full bg-white object-contain p-[1px]" />
                    )}
                    <p className="text-start text-accent text-sm">
                      {job.company} · {job.dates}
                    </p>
                  </div>
                  <p className="text-start text-ink/75 mt-3 text-sm leading-relaxed">{job.description}</p>
                </div>
              </div>
            </MovingBorder>
          </Reveal>
        );
      })}
    </div>
  </section>
);

export default Experience;
